export const CONDITION_TYPE = {
  MANUAL: 0,
  AUTOMATED: 1,
}

export const CONDITION_COLUMN = {
  TAG: 0,
  PRODUCT_OPTION: 1,
  PRODUCT_OPTION_VALUE: 2,
  PRODUCT_SCORE: 3,
  PRODUCT_TYPE: 4,
  PRODUCT_VARIANT_WEIGHT: 5,
  PRODUCT_DISCOUNT: 6,
  PRODUCT_QUANTITY: 7,
  PRODUCT_VARIANT_QUANTITY: 8,
  PRODUCT_TITLE: 9,
  PRODUCT_VARIANT_PRICE: 10,
  PRODUCT_UNDISCOUNTED_PRICE: 11,
  PRODUCT_CATEGORY: 12,
  PRODUCT_VENDOR: 13,
  PRODUCT_PUBLISHED_AT_DAY: 14,
  PRODUCT_LAST_30_DAYS_SALES: 15,
  PRODUCT_CUSTOM_CATEGORY: 16,
  PRODUCT_NEW: 17,
}

export const CONDITION_RELATION = {
  EQUAL: 0,
  NOT_EQUAL: 1,
  GREATER: 2,
  LESS: 3,
  START: 4,
  END: 5,
  CONTAINS: 6,
  NOT_CONTAINS: 7,
  YES: 8,
  NO: 9,
}

export const COMPONENT_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  DC_SELECT: 'dc_select',
}

export const CONDITION_COLUMN_TO_RELATION_MAP = {
  [CONDITION_COLUMN.TAG]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_OPTION]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_OPTION_VALUE]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_SCORE]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.LESS,
    CONDITION_RELATION.GREATER,
  ],
  [CONDITION_COLUMN.PRODUCT_TYPE]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_VARIANT_WEIGHT]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.LESS,
    CONDITION_RELATION.GREATER,
  ],
  [CONDITION_COLUMN.PRODUCT_DISCOUNT]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_QUANTITY]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.LESS,
    CONDITION_RELATION.GREATER,
  ],
  [CONDITION_COLUMN.PRODUCT_VARIANT_QUANTITY]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.LESS,
    CONDITION_RELATION.GREATER,
  ],
  [CONDITION_COLUMN.PRODUCT_TITLE]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
    CONDITION_RELATION.START,
    CONDITION_RELATION.END,
  ],
  [CONDITION_COLUMN.PRODUCT_VARIANT_PRICE]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.LESS,
    CONDITION_RELATION.GREATER,
  ],
  [CONDITION_COLUMN.PRODUCT_UNDISCOUNTED_PRICE]: [CONDITION_RELATION.LESS, CONDITION_RELATION.GREATER],
  [CONDITION_COLUMN.PRODUCT_CATEGORY]: [
    CONDITION_RELATION.EQUAL,
    CONDITION_RELATION.NOT_EQUAL,
    CONDITION_RELATION.CONTAINS,
    CONDITION_RELATION.NOT_CONTAINS,
  ],
  [CONDITION_COLUMN.PRODUCT_VENDOR]: [CONDITION_RELATION.EQUAL],
  [CONDITION_COLUMN.PRODUCT_PUBLISHED_AT_DAY]: [CONDITION_RELATION.GREATER, CONDITION_RELATION.LESS],
  [CONDITION_COLUMN.PRODUCT_LAST_30_DAYS_SALES]: [CONDITION_RELATION.GREATER, CONDITION_RELATION.LESS],
  [CONDITION_COLUMN.PRODUCT_CUSTOM_CATEGORY]: [CONDITION_RELATION.EQUAL],
  [CONDITION_COLUMN.PRODUCT_NEW]: [CONDITION_RELATION.EQUAL],
}

export const CONDITION_COLUMN_TO_COMPONENT_MAP = {
  [CONDITION_COLUMN.TAG]: {
    default: COMPONENT_TYPES.STRING,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_OPTION]: {
    default: COMPONENT_TYPES.STRING,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_OPTION_VALUE]: {
    default: COMPONENT_TYPES.STRING,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_SCORE]: {
    default: COMPONENT_TYPES.NUMBER,
    priceInput: false,
  },
  [CONDITION_COLUMN.PRODUCT_TYPE]: {
    default: COMPONENT_TYPES.STRING,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_VARIANT_WEIGHT]: {
    default: COMPONENT_TYPES.NUMBER,
    priceInput: false,
  },
  [CONDITION_COLUMN.PRODUCT_DISCOUNT]: {
    default: COMPONENT_TYPES.STRING,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_QUANTITY]: {
    default: COMPONENT_TYPES.NUMBER,
    priceInput: false,
  },
  [CONDITION_COLUMN.PRODUCT_VARIANT_QUANTITY]: {
    default: COMPONENT_TYPES.NUMBER,
    priceInput: false,
  },
  [CONDITION_COLUMN.PRODUCT_TITLE]: {
    default: COMPONENT_TYPES.STRING,
  },
  [CONDITION_COLUMN.PRODUCT_VARIANT_PRICE]: {
    default: COMPONENT_TYPES.NUMBER,
    priceInput: true,
  },
  [CONDITION_COLUMN.PRODUCT_UNDISCOUNTED_PRICE]: {
    default: COMPONENT_TYPES.NUMBER,
  },
  [CONDITION_COLUMN.PRODUCT_CATEGORY]: {
    default: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.CONTAINS]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_CONTAINS]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_VENDOR]: {
    default: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.NOT_EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_PUBLISHED_AT_DAY]: {
    default: COMPONENT_TYPES.NUMBER,
  },
  [CONDITION_COLUMN.PRODUCT_LAST_30_DAYS_SALES]: {
    default: COMPONENT_TYPES.NUMBER,
  },
  [CONDITION_COLUMN.PRODUCT_CUSTOM_CATEGORY]: {
    default: COMPONENT_TYPES.DC_SELECT,
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.DC_SELECT,
  },
  [CONDITION_COLUMN.PRODUCT_NEW]: {
    [CONDITION_RELATION.EQUAL]: COMPONENT_TYPES.NUMBER,
  },
}

export const PACKAGE_TYPE = {
  BOX: 0,
  ENVELOPE: 1,
  SOFT_PACKAGE: 2,
}

export const DISCOUNT_TYPE = {
  PERCENT: 0,
  AMOUNT: 1,
  FREE_SHIPPING: 2,
  BUY_X_PAY_Y: 3,
  BUY_X_FREE_Y: 4,
  GIFT_CARD: 5,
  BUY_X_FREE_PRODUCT: 6,
}

export const DISCOUNT_USER_ELIGIBILITY = {
  EVERYONE: null,
  USER: 0,
}

export const DISCOUNT_MINIMUM_REQUIREMENT = {
  NONE: null,
  AMOUNT: 0,
  QUANTITY: 1,
  VARIANT_QUANTITY: 2,
}

export const DISCOUNT_APPLIES_TO = {
  ORDER: 0,
  COLLECTIONS: 1,
  PRODUCTS: 2,
  PRODUCT_TAGS: 3,
}

export const DISCOUNT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  SCHEDULED: 2,
  EXPIRED: 3,
  FINISHED: 4,
}

export const DISCOUNT_STATUSES = [
  DISCOUNT_STATUS.INACTIVE,
  DISCOUNT_STATUS.ACTIVE,
  DISCOUNT_STATUS.SCHEDULED,
  DISCOUNT_STATUS.EXPIRED,
  DISCOUNT_STATUS.FINISHED,
]

export const ZONE_COUNTRY_ZIP_TYPE = {
  INCLUDE: 0,
  EXCLUDE: 1,
}

export const COLLECTION_TYPE = {
  MANUAL: 0,
  AUTOMATED: 1,
}

//                       { label: 'Price', value: 0 },
//                       { label: 'Product Type', value: 1 },
//                       { label: 'Gender', value: 2 },
//                       { label: 'Option', value: 3 },
//                       { label: 'Vendor/Brand', value: 4 }
export const COLLECTION_FILTER_TYPE = {
  PRICE: 0,
  PRODUCT_TYPE: 1,
  GENDER: 2,
  OPTION: 3,
  VENDOR: 4,
  CATEGORY: 5,
}

export const PRODUCT_STATUS = {
  DRAFT: 0,
  PUBLISHED: 1,
}

// Order Type
// define('ORDER_TYPE_WAITING_INFORMATION', 0);
// define('ORDER_TYPE_WAITING_SHIPPING', 1);
// define('ORDER_TYPE_WAITING_PAYMENT', 2);
// define('ORDER_TYPE_OPEN', 4);
// define('ORDER_TYPE_SHIPPED', 5);
// define('ORDER_TYPE_WAITING_DELIVERY_INFORMATION', 6);
// define('ORDER_TYPE_RETURNED', 7);
// define('ORDER_TYPE_PROCESSING', 8);
// define('ORDER_TYPE_ON_HOLD', 9);
// define('ORDER_TYPE_CANCELLED', 11);
// define('ORDER_TYPE_PARTIALLY_RETURNED', 12);

export const ORDER_TYPES = {
  WAITING_INFORMATION: 0,
  WAITING_SHIPPING: 1,
  WAITING_PAYMENT: 2,
  OPEN: 4,
  SHIPPED: 5,
  WAITING_DELIVERY_INFORMATION: 6,
  RETURNED: 7,
  PROCESSING: 8,
  ON_HOLD: 9,
  CANCELLED: 11,
  PARTIALLY_RETURNED: 12,
}

export const ORDER_TYPE_COLORS = {
  [ORDER_TYPES.WAITING_INFORMATION]: 'gray',
  [ORDER_TYPES.WAITING_PAYMENT]: 'gray',
  [ORDER_TYPES.WAITING_DELIVERY_INFORMATION]: 'gray',
  [ORDER_TYPES.OPEN]: 'yellow',
  [ORDER_TYPES.WAITING_SHIPPING]: 'yellow',
  [ORDER_TYPES.SHIPPED]: 'green',
  [ORDER_TYPES.RETURNED]: 'red',
  [ORDER_TYPES.PROCESSING]: 'lime',
  [ORDER_TYPES.ON_HOLD]: 'red',
  [ORDER_TYPES.CANCELLED]: 'brown',
  [ORDER_TYPES.PARTIALLY_RETURNED]: 'pink',
}

// define('ORDER_PAYMENT_METHOD_MANUAL', 0);
// define('ORDER_PAYMENT_METHOD_AMAZON', 1);
// define('ORDER_PAYMENT_METHOD_PAYPAL', 2);
// define('ORDER_PAYMENT_METHOD_KLARNA', 3);
// define('ORDER_PAYMENT_METHOD_SAGEPAY', 4);
// define('ORDER_PAYMENT_METHOD_GOOGLEPAY', 5);
// define('ORDER_PAYMENT_METHOD_JUDOPAY', 6);
// define('ORDER_PAYMENT_METHOD_PAYPAL_EXPRESS', 7);
// define('ORDER_PAYMENT_METHOD_GOOGLEPAY_EXPRESS', 8);
// define('ORDER_PAYMENT_METHOD_APPLEPAY', 9);
// define('ORDER_PAYMENT_METHOD_APPLEPAY_EXPRESS', 10);

export const PAYMENT_METHODS = {
  MANUAL: 0,
  AMAZON: 1,
  PAYPAL: 2,
  KLARNA: 3,
  SAGEPAY: 4,
  GOOGLEPAY: 5,
  JUDOPAY: 6,
  PAYPAL_EXPRESS: 7,
  GOOGLEPAY_EXPRESS: 8,
  APPLEPAY: 9,
  APPLEPAY_EXPRESS: 10,
  GIFT_CARD: 11,
  FREE_PAY: 12,
  VIRTUAL_TERMINAL: 13,
  SHOW_TERMINAL: 14,
}

export const PAYMENT_METHOD_ICONS = {
  // fontawesome icons
  [PAYMENT_METHODS.MANUAL]: 'fas fa-money-bill-wave',
  [PAYMENT_METHODS.AMAZON]: 'fab fa-amazon-pay',
  [PAYMENT_METHODS.PAYPAL]: 'fab fa-paypal',
  [PAYMENT_METHODS.KLARNA]: 'fas fa-credit-card',
  [PAYMENT_METHODS.SAGEPAY]: 'fas fa-credit-card',
  [PAYMENT_METHODS.GOOGLEPAY]: 'fab fa-google-pay',
  [PAYMENT_METHODS.JUDOPAY]: 'fas fa-credit-card',
  [PAYMENT_METHODS.PAYPAL_EXPRESS]: 'fab fa-paypal',
  [PAYMENT_METHODS.GOOGLEPAY_EXPRESS]: 'fab fa-google-pay',
  [PAYMENT_METHODS.APPLEPAY]: 'fab fa-apple-pay',
  [PAYMENT_METHODS.APPLEPAY_EXPRESS]: 'fab fa-apple-pay',
  [PAYMENT_METHODS.GIFT_CARD]: 'fas fa-gift-card',
  [PAYMENT_METHODS.FREE_PAY]: 'fas fa-check-circle',
  [PAYMENT_METHODS.VIRTUAL_TERMINAL]: 'fas fa-terminal',
  [PAYMENT_METHODS.SHOW_TERMINAL]: 'fas fa-check-square',
}

export const PAYMENT_METHOD_COLORS = {
  [PAYMENT_METHODS.MANUAL]: 'bg-gray-500',
  [PAYMENT_METHODS.AMAZON]: 'bg-yellow-500',
  [PAYMENT_METHODS.PAYPAL]: 'bg-blue-600',
  [PAYMENT_METHODS.KLARNA]: 'bg-pink-500',
  [PAYMENT_METHODS.SAGEPAY]: 'bg-green-600',
  [PAYMENT_METHODS.GOOGLEPAY]: 'bg-gray-800',
  [PAYMENT_METHODS.JUDOPAY]: 'bg-purple-600',
  [PAYMENT_METHODS.PAYPAL_EXPRESS]: 'bg-blue-600',
  [PAYMENT_METHODS.GOOGLEPAY_EXPRESS]: 'bg-gray-800',
  [PAYMENT_METHODS.APPLEPAY]: 'bg-black',
  [PAYMENT_METHODS.APPLEPAY_EXPRESS]: 'bg-black',
  [PAYMENT_METHODS.GIFT_CARD]: 'bg-red-500',
  [PAYMENT_METHODS.FREE_PAY]: 'bg-green-500',
  [PAYMENT_METHODS.VIRTUAL_TERMINAL]: 'bg-indigo-600',
  [PAYMENT_METHODS.SHOW_TERMINAL]: 'bg-indigo-600',
}

export const TRAFFIC_SOURCES = {
  META_PAID: 'meta_paid',
  META_ORGANIC: 'meta_organic',
  OTHER: 'other',
  GOOGLE_PAID: 'google_paid',
  GOOGLE_ORGANIC: 'google_organic',
  BING_PAID: 'bing_paid',
  PAID_OTHER: 'paid_other',
  ORGANIC_SEARCH: 'organic_search',
  EMAIL: 'email',
  REFERRAL: 'referral',
}

export const TRAFFIC_SOURCE_COLORS = {
  [TRAFFIC_SOURCES.META_PAID]: 'bg-blue-200 text-blue-800',
  [TRAFFIC_SOURCES.META_ORGANIC]: 'bg-green-200 text-green-800',
  [TRAFFIC_SOURCES.OTHER]: 'bg-gray-200 text-gray-800',
  [TRAFFIC_SOURCES.GOOGLE_PAID]: 'bg-yellow-200 text-yellow-800',
  [TRAFFIC_SOURCES.BING_PAID]: 'bg-orange-200 text-orange-800',
  [TRAFFIC_SOURCES.PAID_OTHER]: 'bg-amber-200 text-amber-800',
  [TRAFFIC_SOURCES.GOOGLE_ORGANIC]: 'bg-teal-200 text-teal-800',
  [TRAFFIC_SOURCES.ORGANIC_SEARCH]: 'bg-cyan-200 text-cyan-800',
  [TRAFFIC_SOURCES.EMAIL]: 'bg-purple-200 text-purple-800',
  [TRAFFIC_SOURCES.REFERRAL]: 'bg-pink-200 text-pink-800',
  unattributed: 'bg-gray-100 text-gray-600',
}

export const TRAFFIC_SOURCE_LABELS = {
  [TRAFFIC_SOURCES.META_PAID]: 'Meta Paid',
  [TRAFFIC_SOURCES.META_ORGANIC]: 'Meta Organic',
  [TRAFFIC_SOURCES.OTHER]: 'Other',
  [TRAFFIC_SOURCES.GOOGLE_PAID]: 'Google Paid',
  [TRAFFIC_SOURCES.GOOGLE_ORGANIC]: 'Google Organic',
  [TRAFFIC_SOURCES.BING_PAID]: 'Bing Paid',
  [TRAFFIC_SOURCES.PAID_OTHER]: 'Paid (Other)',
  [TRAFFIC_SOURCES.ORGANIC_SEARCH]: 'Organic Search',
  [TRAFFIC_SOURCES.EMAIL]: 'Email',
  [TRAFFIC_SOURCES.REFERRAL]: 'Referral',
  unattributed: 'Unattributed',
}

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.MANUAL]: 'Manual',
  [PAYMENT_METHODS.AMAZON]: 'Amazon Pay',
  [PAYMENT_METHODS.PAYPAL]: 'PayPal',
  [PAYMENT_METHODS.KLARNA]: 'Klarna',
  [PAYMENT_METHODS.SAGEPAY]: 'SagePay',
  [PAYMENT_METHODS.GOOGLEPAY]: 'Google Pay',
  [PAYMENT_METHODS.JUDOPAY]: 'Judo Pay',
  [PAYMENT_METHODS.PAYPAL_EXPRESS]: 'PayPal Express',
  [PAYMENT_METHODS.GOOGLEPAY_EXPRESS]: 'Google Pay Express',
  [PAYMENT_METHODS.APPLEPAY]: 'Apple Pay',
  [PAYMENT_METHODS.APPLEPAY_EXPRESS]: 'Apple Pay Express',
  [PAYMENT_METHODS.GIFT_CARD]: 'Gift Card',
  [PAYMENT_METHODS.FREE_PAY]: 'Free Pay',
  [PAYMENT_METHODS.VIRTUAL_TERMINAL]: 'Virtual Terminal',
  [PAYMENT_METHODS.SHOW_TERMINAL]: 'Show Terminal',
}

// Meta Key Special Types
export const META_KEY_SPECIAL_TYPES = {
  SIZE_GUIDE: 0,
  MATERIALS: 1,
  CARE_INSTRUCTIONS: 2,
}

// Meta Key Types
export const META_KEY_TYPES = {
  STRING: 0,
  NUMBER: 1,
  HTML: 2,
}

// Media resized widths
export const MEDIA_WIDTHS = [100, 280, 340, 400, 460, 560, 680, 800, 920]

// Shipping Rate Types
export const SHIPPING_RATE_TYPES = {
  ALL: 0,
  EXPRESS: 1,
  NORMAL: 2,
}

/** Currency Change > Country Items **/
export const locales = [
  {
    code: 'en',
    iso: 'en-GB',
    name: 'English',
    symbol: '£',
    currencyCode: 'GBP',
  },
  {
    code: 'us',
    iso: 'en-US',
    name: 'English (US)',
    symbol: '$',
    currencyCode: 'USD',
    tooltip:
      'If you want to customize the content for the us, you can fill fields otherwise it will use the English (UK) content',
  },
  {
    code: 'de',
    iso: 'de-DE',
    name: 'German',
    symbol: '€',
    currencyCode: 'EUR',
  },
  {
    code: 'fr',
    iso: 'fr-FR',
    name: 'French',
    symbol: '€',
    currencyCode: 'EUR',
  },
  {
    code: 'es',
    iso: 'es-ES',
    name: 'Spanish',
    symbol: '€',
    currencyCode: 'EUR',
  },
]

export const externalLocales = locales.filter((m) => m.code !== 'en')

export const LANGUAGE_CODES = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
}

export const COMMENT_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  SPAM: 2,
  TRASH: 3,
}

export const ORDER_TRACKING_STATUS_CODES = {
  BOOKED: 1,
  COLLECTED: 2,
  AT_HUB: 3,
  IN_TRANSIT: 4,
  OUT_FOR_DELIVERY: 5,
  FAILED_ATTEMPT: 6,
  DELIVERED: 7,
  ON_HOLD: 8,
  ADDRESS_ISSUE: 9,
  RETURNED_TO_SENDER: 10,
  TRACKING_EXPIRED: 11,
  CANCELLED: 12,
  AWAITING_CUSTOMER_COLLECTION: 13,
}

export const ORDER_TRACKING_STATUS_CODE_LABELS = {
  [ORDER_TRACKING_STATUS_CODES.BOOKED]: 'Booked',
  [ORDER_TRACKING_STATUS_CODES.COLLECTED]: 'Collected',
  [ORDER_TRACKING_STATUS_CODES.AT_HUB]: 'At Hub',
  [ORDER_TRACKING_STATUS_CODES.IN_TRANSIT]: 'In Transit',
  [ORDER_TRACKING_STATUS_CODES.OUT_FOR_DELIVERY]: 'Out for Delivery',
  [ORDER_TRACKING_STATUS_CODES.FAILED_ATTEMPT]: 'Failed Attempt',
  [ORDER_TRACKING_STATUS_CODES.DELIVERED]: 'Delivered',
  [ORDER_TRACKING_STATUS_CODES.ON_HOLD]: 'On Hold',
  [ORDER_TRACKING_STATUS_CODES.ADDRESS_ISSUE]: 'Address Issue',
  [ORDER_TRACKING_STATUS_CODES.RETURNED_TO_SENDER]: 'Returned to Sender',
  [ORDER_TRACKING_STATUS_CODES.TRACKING_EXPIRED]: 'Tracking Expired',
  [ORDER_TRACKING_STATUS_CODES.CANCELLED]: 'Cancelled',
  [ORDER_TRACKING_STATUS_CODES.AWAITING_CUSTOMER_COLLECTION]: 'Awaiting Customer Collection',
}

// AI Request Log Status
export const AI_REQUEST_LOG_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  COMPLETED: 2,
  FAILED: 3,
}

export const AI_REQUEST_LOG_STATUS_COLORS = {
  [AI_REQUEST_LOG_STATUS.PENDING]: 'bg-gray-500',
  [AI_REQUEST_LOG_STATUS.PROCESSING]: 'bg-yellow-500',
  [AI_REQUEST_LOG_STATUS.COMPLETED]: 'bg-green-500',
  [AI_REQUEST_LOG_STATUS.FAILED]: 'bg-red-500',
}

export const AI_REQUEST_LOG_STATUS_LABELS = {
  [AI_REQUEST_LOG_STATUS.PENDING]: 'Pending',
  [AI_REQUEST_LOG_STATUS.PROCESSING]: 'Processing',
  [AI_REQUEST_LOG_STATUS.COMPLETED]: 'Completed',
  [AI_REQUEST_LOG_STATUS.FAILED]: 'Failed',
}

// Pallet shipping (RYTC-375)
// The backend reserves shipping rate type ids [100, 200) for pallet types and
// auto-assigns one when a Pallet Type is created. Pallet shipping is YTC-only,
// so a Rydale admin must never be offered these on an ordinary profile.
export const PALLET_RATE_TYPE_FLOOR = 100
